import React from 'react';

import styled from 'styled-components';

import NwSegmented from '@components/Gui/NwForm/NwSegmented';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';

import NwIcon from '../NwIcon';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const StyledSegmented = styled(NwSegmented)`
    .label {
        padding: 0.5rem;

        .label-icon {
            font-size: 1.2rem;
        }
        .label-text {
            font-size: 1rem;
            text-transform: uppercase;
        }
    }
    .ant-segmented-item-selected {
        .label {
            .label-icon {
                color: ${(props) => props.theme.PrimaryColor};
            }
            &.empty {
                .label-icon {
                    color: ${(props) => props.theme.TextColorMuted};
                }
                .label-text {
                    font-weight: normal;
                    color: ${(props) => props.theme.TextColorMuted};
                }
            }
        }
    }
`;

export const SegmentedOptionContent = ({ text, icon, empty }) => (
    <div className={`label ${empty ? 'empty' : ''}`}>
        {icon && (
            <div className="label-icon">
                <NwIcon icon={icon} />
            </div>
        )}
        <div className="label-text">{text}</div>
    </div>
);

const InTownSelector = ({ value, disabled, onChange, emptyValue, asSegmented }) => {
    const optionsAsSegmented = [
        {
            label: <SegmentedOptionContent text="In Town" icon={byPrefixAndName.fasl['location-smile']} />,
            value: true,
        },
        {
            label: <SegmentedOptionContent text="Out" icon={byPrefixAndName.fasl['island-tropical']} />,
            value: false,
        },
    ];
    if (emptyValue) {
        optionsAsSegmented.unshift({
            label: <SegmentedOptionContent empty text="Any" icon={byPrefixAndName.fasl['globe']} />,
            value: null,
        });
    }

    const options = [
        {
            label: 'In Town',
            icon: byPrefixAndName.fasl['location-smile'],
            value: true,
        },
        {
            label: 'Out',
            icon: byPrefixAndName.fasl['island-tropical'],
            value: false,
        },
    ];
    if (emptyValue) {
        options.unshift({
            label: 'Any',
            icon: byPrefixAndName.fasl['globe'],
            value: null,
        });
    }

    if (asSegmented) {
        return (
            <StyledSegmented
                options={optionsAsSegmented}
                value={value}
                disabled={disabled}
                onChange={onChange}
                defaultValue={emptyValue ? null : false}
            />
        );
    }
    return (
        <RadioButtonGroup
            value={value}
            disabled={disabled}
            onChange={onChange}
            defaultValue={emptyValue ? null : false}
            options={options}
        />
    );
};

export default InTownSelector;
